import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

export default class UnlimitedStorageExperiment {
  static key = 'unlimited-storage-experiment';

  static variations = {
    control: 'control',
    asterisk: 'asterisk',
    fixedStorage: 'fixedstorage',
  };

  static isControl(): boolean {
    return this.currentVariant() === this.variations.control;
  }

  // Mentions "Unlimited storage" with a footnote explaining the initial 5 TB storage limit
  static isAsterisk(): boolean {
    return this.currentVariant() === this.variations['asterisk'];
  }

  // Directly mentions 5 TB as an initial storage limit
  static isFixedStorage(): boolean {
    return this.currentVariant() === this.variations['fixedStorage'];
  }

  static currentVariant(): string {
    return getFullVariant(this.key, { value: this.variations.control })
      .value as string;
  }
}
